import React from 'react';

interface BellNotificationIconProps {
  size?: number;
  color?: string;
}

/**
 * BellNotificationIcon Component
 * @description A bell notification icon for alerts and notifications
 */
export const BellNotificationIcon: React.FC<BellNotificationIconProps> = ({ 
  size = 20, 
  color = '#101018' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 20 20"
    >
      <path 
        fill={color} 
        d="M5.357 2.01a.625.625 0 0 0-.941-.82L3.339 2.421c-.61.7-.956 1.592-.975 2.52l-.047 2.266a.625.625 0 1 0 1.25.026l.046-2.265c.014-.635.25-1.245.668-1.724z"
      />
      <path 
        fill={color} 
        fillRule="evenodd" 
        d="M5.198 6.417a3.51 3.51 0 0 1 3.505-3.292h.464V2.5a.833.833 0 0 1 1.667 0v.625h.464a3.51 3.51 0 0 1 3.505 3.292l.184 2.945a6.17 6.17 0 0 0 1.09 3.128 1.348 1.348 0 0 1-.946 2.108l-2.84.34v.895a2.292 2.292 0 0 1-4.583 0v-.895l-2.839-.341a1.346 1.346 0 0 1-.946-2.107 6.17 6.17 0 0 0 1.09-3.128zm3.76 9.416a1.042 1.042 0 0 0 2.084 0v-.625H8.958z" 
        clipRule="evenodd"
      />
      <path 
        fill={color} 
        d="M14.702 1.13a.625.625 0 0 0-.06.88l1.077 1.234c.418.48.654 1.09.667 1.725l.047 2.264a.625.625 0 1 0 1.25-.026l-.047-2.265a3.96 3.96 0 0 0-.975-2.52L15.584 1.19a.625.625 0 0 0-.882-.06"
      />
    </svg>
  );
};

export default BellNotificationIcon;

